import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Patient } from "../../../../interfaces/api/patients";

interface PatientsState {
  data: Patient[];
  loading: boolean;
  error: string | null;
}

const initialState: PatientsState = {
  data: [],
  loading: false,
  error: null,
};

export const patientsSlice = createSlice({
  name: "patients",
  initialState,
  reducers: {
    setPatients: (state, action: PayloadAction<Patient[]>) => {
      state.data = action.payload;
    },
  },
});

export const { setPatients } = patientsSlice.actions;

export default patientsSlice.reducer;
